/*
 * MAGNUM HOME & WINE - Scroll-/Reveal-Logik fuer die Startseite.
 * Editorial verwaltet seine Bewegung selbst und wird hier bewusst ausgeschlossen.
 */
(() => {
  if (window.__magnumMotionInit) return;
  window.__magnumMotionInit = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealElements = document.querySelectorAll('[data-magnum-reveal]:not(.magnum-editorial)');

  if (reduceMotion) {
    revealElements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14 });

    revealElements.forEach((element) => observer.observe(element));
  } else {
    revealElements.forEach((element) => element.classList.add('is-visible'));
  }

  const getHeroImages = () => document.querySelectorAll('.magnum-hero__image');
  const getSlideImages = () => document.querySelectorAll('[data-magnum-slide]:not(.magnum-editorial__picture) img');
  let motionTicking = false;

  const updateMotion = () => {
    getHeroImages().forEach((image) => {
      const hero = image.closest('.magnum-hero');
      if (!hero) return;

      const rect = hero.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        image.style.setProperty('--magnum-parallax', `${Math.max(-34, rect.top * -0.045)}px`);
      }
    });

    getSlideImages().forEach((image) => {
      const media = image.parentElement;
      if (!media) return;

      const rect = media.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) {
        const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
        const offset = Math.max(-11, Math.min(0, -11 + progress * 11));
        image.style.setProperty('--magnum-picture-y', `${offset}%`);
      }
    });
  };

  const requestMotion = () => {
    if (motionTicking) return;
    motionTicking = true;
    window.requestAnimationFrame(() => {
      motionTicking = false;
      updateMotion();
    });
  };

  updateMotion();
  window.addEventListener('scroll', requestMotion, { passive: true });
  window.addEventListener('resize', requestMotion);
  document.addEventListener('shopify:section:load', requestMotion);
})();
